import { Race } from './Participant'

export interface CheckboxItem extends RadioItem {
	checked: boolean
}

export interface RadioItem {
	label: string
	value: string | Race
}

export enum BinaryChoice {
	YES = 'Yes',
	NO = 'No',
	NA = ''
}

export const BinaryChoiceItems: string[] = Object.keys(BinaryChoice).filter(i => isNaN(+i));